<div class="col-md-12 mb-30">
    <div class="card card-statistics h-100">
      <div class="card-body">
        <h5 class="card-title border-0 pb-0">اطلاعات فلوچارت ها</h5>
        <br />
        <br />
        <div class="row">
          <div class="form-group col-md-6">
            <label for="exampleInputEmail1">عنوان</label>
            <input [(ngModel)]="Filter_title" (keyup)="Change_Filter_title()" name="Filter_title" type="text"
              class="form-control" placeholder="برای جستجوی ، اینجا تایپ کنید ...">
          </div>
        </div>
        <div class="row">
          <div class="form-group col-md-6">
            <button *ngIf="!Procssing" type="button" (click)="ReadData_Flowchart()" class="btn btn-info" style="margin-left: 5px;"><i
                class="fa  fa-search"></i> جستجوی اطلاعات </button>
            <a *ngIf="!Procssing" href="{{BaseUrl}}" target="_blank" type="button" class="btn btn-success" style="margin-left: 5px;"><i
                class="fa  fa-plus-circle"></i> فرم ثبت اطلاعات جدید </a>
            <img *ngIf="Procssing" src="assets/Loading.gif" style="width: 25px;" />
          </div>
        </div>
  
        <div class="table-responsive">
          <table class="mb-0 table table-bordered table-3 text-center table-striped">
            <thead style="background-color: #489b39; color: white;">
              <tr>
                <th>#</th>
                <th>کد</th>
                <th>عنوان</th>
                <th>وضیعت</th>
                <th>تاریخ</th>
                <th>کاربر</th>
                <th>امکانات</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let item of DataList_Flowchart
              |filter:Filter_title:'title'
              | paginate
                      : {
                          id: 'DataList_FeildTable',
                          itemsPerPage: 50,
                          currentPage: page,
                          totalItems: (DataList_Flowchart|filter:Filter_title:'title').length
                        }
              ">
                <td>{{DataList_Flowchart.indexOf(item)+1}}</td>
                <td>{{item.code}}</td>
                <td>{{item.title}}</td>
                <td>
                  <p *ngIf="!item.del" style="color: #489b39;">فعال</p>
                  <p *ngIf="item.del" style="color: crimson;">غیر فعال</p>
                </td>
                <td>{{item.persianDate}}</td>
                <td>{{item.username}} </td>
                <td>
                  <div class="btn-group  " role="group" aria-label="دکمه group with nested dropdown">
                    <div  class="btn-group" role="group">
                      <button id="btnGroupDrop1" type="button" class="btn btn-warning dropdown-toggle"
                        data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                        امکانات
                      </button>
                      <div class="dropdown-menu" aria-labelledby="btnGroupDrop1">
                        <a href="{{BaseUrl1}}{{item.id}}" *ngIf="item.del==false" target="_blank" class="dropdown-item"><i class="fa fa-eye"></i>
                          مشاهده/ثبت گردش کار
                        </a>
                        <a *ngIf="item.del==false" style="cursor: pointer;" class="dropdown-item"
                          (click)="openModal(template,item)"><i class="fa fa-lock"></i> غیرفعال </a>
                        <a *ngIf="item.del==true" style="cursor: pointer;" class="dropdown-item"
                          (click)="openModal(template,item)"><i class="fa fa-unlock"></i> فعال </a>
                      </div>
                    </div>
  
                    <div *ngIf="item.DeletingProccess">
                      <img src="assets/Loading.gif" style="width: 25px;" />
                    </div>
                  </div>
                </td>
  
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <pagination-controls id="DataList_FeildTable" nextLabel="بعدی" previousLabel="قبلی" (pageChange)="page = $event">
      </pagination-controls>
    </div>
  </div>
  
  <ng-template #template>
    <div class="modal-header">
      <h4 *ngIf="Data_Seleted_Delete.del==false" class="modal-title pull-left">تایید غیرفعال اطلاعات فلوچارت
        '{{Data_Seleted_Delete.title}}' </h4>
      <h4 *ngIf="Data_Seleted_Delete.del==true" class="modal-title pull-left">تایید فعال اطلاعات فلوچارت
        '{{Data_Seleted_Delete.title}}' </h4>
      <button type="button" class="close pull-right" aria-label="Close" (click)="modalRef_Delete.hide()">
        <span aria-hidden="true">×</span>
      </button>
    </div>
    <div class="modal-footer">
      <button *ngIf="Data_Seleted_Delete.del==false" type="button" class="btn btn-warning"
        (click)="Delete(Data_Seleted_Delete)"> غیرفعال اطلاعات <i class="fa fa-lock"></i></button>
      <button *ngIf="Data_Seleted_Delete.del==true" type="button" class="btn btn-warning"
        (click)="Delete(Data_Seleted_Delete)"> فعال اطلاعات <i class="fa fa-unlock"></i></button>
      <button type="button" class="btn btn-danger" (click)="modalRef_Delete.hide()">بستن</button>
    </div>
  </ng-template>